module.exports = __webpack_public_path__ + "static/video_poster_05.d36d70d4.png";